<template>
  <v-autocomplete
    v-bind="$attrs"
    @input="updateFieldValue(name, $event)"
    @change="$emit('changed', $event)"
    :value="currentValue"
    :messages="[error]"
    :error="!!error"
    :items="items"
    :loading="isLoading"
    :outlined="outlined"
    :search-input.sync="search"
    color="accent"
    :item-text="item_name"
    :item-value="item_value"
    v-model="select"
    hide-no-data
    hide-selected
    clearable
    no-data-text="No results found/loaded yet"
    placeholder="Start typing to Search"
    :prepend-inner-icon="icon"
  >
    <template v-slot:item="{ item }">
      <span class="body-2">{{ item.name}}</span>
      <strong class="px-1 font-weight-bold text-lowercase text-caption">
        ({{ item.commercial_name || '' }})
      </strong>
    </template>

    <template v-slot:selection="{ item }">
      <span class="body-2">{{ item.name}}</span>
      <strong class="px-1 font-weight-bold text-lowercase text-caption">
        {{ '(' + item.commercial_name + ')' || '' }}
      </strong>
    </template>
  </v-autocomplete>
</template>

<script>
import baseInput from "./baseInput";
import debounce from "lodash/debounce";

export default {
  props: {
    icon: { default: "mdi-search", type: String },
    outlined: { default: true, type: Boolean },
    item_name: { required: true, type: String },
    item_value: { required: true, type: String },
    existing_campaign: { type: Array, default: () => [] },
    selectedCampaign: { type: Object, default: () => null },
  },
  mixins: [baseInput],
  data() {
    return {
      items: this.existing_campaign || [],
      isLoading: false,
      select: this.existing_campaign[0],
      search: null,
    };
  },

  computed: {},

  mounted() {
    if (this.selectedCampaign) {
      this.select = this.selectedCampaign[this.item_value];
    }
  },

  watch: {
    search(value) {
      return this.searchResults(value);
    },
  },

  methods: {
    searchResults: debounce(function (value) {
      if (this.isLoading || !value) return;
      this.isLoading = true;

      this.$http
        .get(`api/v1/campaigns/search?search=${encodeURIComponent(value)}`)
        .then(({ data }) => {
          this.items = data;
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {})
        .finally(() => (this.isLoading = false));
    }, 500),
  },
};
</script>
